<template>
    <v-card
            :width="width"
            :min-width="width"
            style="height: 100%;"
    >
        <v-navigation-drawer
                :width="width"
                :value="true"
                :color="color"
                :dark="dark"
                permanent
                absolute
        >
            <v-list class="vertical-menu">
                <div class="vertical-menu__header cursor logo" @click="setSideMenuHide" >
                    <div>
                        <img src="@/assets/image/admin_logo.png">
                    </div>
                </div>

                <div class="vertical-menu__body">
                    <template v-for="(menu, i) in menus">
                        <template
                                v-if="utilManager.isEmpty(menu.permission) || userManager.hasPermission(menu.permission)">
                            <!-- 메뉴 그룹 -->
                            <v-list-group
                                    :key="'menu-' + i"
                                    value="true"
                                    v-if="utilManager.isNotEmpty(menu.children)"
                                    :color="listItemGroupColor"
                            >
                                <template v-slot:activator>
                                    <v-icon v-if="menu.icon" class="mr-2">{{menu.icon}}</v-icon>
<!--                                    <v-list-item-title>{{menu.text}}</v-list-item-title>-->
                                </template>

                                <template v-for="(child, j) in menu.children">
                                    <template
                                            v-if="utilManager.isEmpty(child.permission) || userManager.hasPermission(child.permission)">
                                        <!-- 자식 그룹 -->
                                        <v-list-group
                                                :key="'children-' + j"
                                                v-if="utilManager.isNotEmpty(child.subChildren)"
                                                no-action
                                                sub-group
                                                value="true"
                                                :color="listItemGroupColor"
                                                :style="groupStyle"
                                        >
                                            <template v-slot:activator>
                                                <v-list-item-content>
                                                    <v-list-item-title><span :title="child.text | translate">{{child.text | translate}}</span></v-list-item-title>
                                                </v-list-item-content>
                                            </template>

                                            <!-- 손자 목록 -->
                                            <v-list-item
                                                    v-for="(subChild, k) in child.subChildren"
                                                    @click="onClick(subChild)"
                                                    :key="'sub-children-' + k"
                                                    link
                                            >
                                                <template
                                                        v-if="utilManager.isEmpty(subChild.permission) || userManager.hasPermission(subChild.permission)">
                                                    <!-- 손자 타이틀 -->
                                                    <v-list-item-title>
                                                        <span :title="subChild.text | translate">{{subChild.text | translate}}</span>
                                                    </v-list-item-title>
                                                </template>
                                            </v-list-item>
                                        </v-list-group>


                                        <!-- 자식 단일 메뉴 -->
                                        <!-- 손자 목록 -->
                                        <v-list-item v-else :key="'children-' + j" @click="onClick(child)" class="pl-9"
                                                     :style="groupStyle">
                                            <v-list-item-title>
                                                <span :title="child.text | translate">{{child.text | translate}}</span>
                                                <menu-beta-badge v-if="isBetaMenuLink(child.id)" />
                                            </v-list-item-title>
                                        </v-list-item>
                                    </template>
                                </template>
                            </v-list-group>

                            <!-- 단일 메뉴 타이틀 -->
                            <v-list-item v-else link :key="'menu-' + i" @click="onClick(menu)">
                                <v-icon v-if="menu.icon" class="mr-2">{{menu.icon}}</v-icon>
<!--                                <v-list-item-title>{{menu.text}}</v-list-item-title>-->
                            </v-list-item>
                        </template>
                    </template>
                </div>

                <div class="vertical-menu__footer">
                    <div class="px-3 pb-3">
                        <v-btn block color="black" @click="userManager.logout()">Logout</v-btn>
                    </div>
                </div>
            </v-list>
        </v-navigation-drawer>
    </v-card>
</template>

<script>
    import MultiChildrenVerticalMenu from "./MultiChildrenVerticalMenu";
    import MenuBetaBadge from '@/components/common/MenuBetaBadge.vue'

    export default {
        name: "MultiChildrenVerticalMenu",
        mixins: [MultiChildrenVerticalMenu],
        components: { MenuBetaBadge },
        props: {},
        data() {
            return {}
        },
        computed: {},
        methods: {},
    }
</script>

<style scoped>
    .cursor {
        cursor: pointer;
    }

    .vertical-menu {
        text-align: left;
        display: flex;
        flex-direction: column;
        justify-content: stretch;
        width: 100%;
        height: 100%;
        overflow: hidden;
    }

    .vertical-menu__header {
        flex-grow: 0;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .logo {
        height: 150px;
        border-bottom: 1px solid rgba(255, 255, 255, 0.15)
    }

    .vertical-menu__body {
        flex-grow: 1;
        overflow-y: auto;
    }

    .vertical-menu__footer {
        padding-top: 20px;
        flex-grow: 0;
    }

    .logo_tnbox {
        display: flex;
    }

    .logo_tnbox > img {
        width: 22px;
    }

    .logo_tnbox > div {
        line-height: 22px;
    }

    .vertical_menu_top_section {
        padding: 20px 0;
        border-bottom: 1px solid rgba(255, 255, 255, 0.3);
    }

    .vertical_menu_top_section_text {
        font-size: 1.5rem;
    }

    .active_menu_class {
        background-color: rgba(255, 255, 255, 0.7);
    }
</style>